const initialState = [];

export const selectedBPScheduleReducer = (state = initialState, action) => {
    if (action.type === 'SET_BP_SCHEDULE_SELECTED') {
        const count = state.some(item => action.payload.programId === item.programId);
        if (count === false) {
            return [...state, action.payload]
        } else {
            return state.map((item) => {
                if (item.programId === action.payload.programId) {
                    return { ...item, ...action.payload }
                }
                return item
            })
        }
    } else if (action.type === 'UNSET_BP_SCHEDULE_SELECTED') {
        return state.filter((item) => action.payload.bpId !== item.bpId);

    } else if (action.type === 'SET_BP_PARTICIPANT_TO_SCHEDULE') {
        return state.map((item) => {
            return {
                ...item,
                participants: [...item.participants, action.payload]
            }
            return item
        })
    } else if (action.type === 'UNSET_BP_PARTICIPANT_TO_SCHEDULE') {
        return state.map((item) => {
            if (item.bpiId === action.bpiId) {
                return {
                    ...item,
                    participants: item.participants.filter((p) => p.email !== action.payload)
                }
            }
            return item
        })
    } else if (action.type === 'UPDATE_BP_PARTICIPANT_TO_SCHEDULE') {
        return state.map((item) => {
            if (item.bpId === action.bpId) {
                return {
                    ...item,
                    participants: item.participants.map(
                        (participant, i) => participant.email === action.payload.emailOld ?
                            {
                                ...participant,
                                email: action.payload.email,
                                firstName: action.payload.firstName,
                                lastName: action.payload.lastName,
                                mobilePhone: action.payload.mobilePhone,
                            }
                            :
                            participant
                    )
                }
            }
            return item
        })
    }
    return state
}